import React from "react";
import { Box, Typography } from "@material-ui/core";

/** Full-height placeholder used by the ticket and printable views, matching
 *  components/digital-ticket/digital-ticket-view.tsx. */
const TicketLoading = () => (
  <Box
    sx={{
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      height: "100vh",
      width: "100%",
    }}
  >
    <Typography variant="h3">Loading...</Typography>
  </Box>
);

export default TicketLoading;
